import { LOGIN_STATUS } from "../reducers/Types";

const LoginStatus = (payload) => {
	return {
		type: LOGIN_STATUS,
		payload: payload,
	};
};

export default LoginStatus;
